"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CloseIcon;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function CloseIcon(_ref) {
  var rest = _extends({}, _ref);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/_react["default"].createElement("g", {
    id: "User-management",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Add-user-via-invite",
    transform: "translate(-1009.000000, -212.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Modal",
    transform: "translate(380.000000, 175.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Content",
    transform: "translate(32.000000, 32.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Action-/-clear",
    transform: "translate(592.000000, 0.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Bounds",
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "Icon",
    fillOpacity: "0.4",
    fill: "#000000",
    points: "19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12"
  }))))))));
}